export default "__VITE_ASSET__CRMYDNQt__"